import { FC } from 'react';
import { Plus } from 'lucide-react';
import { useAppDispatch } from '@/lib/hooks/hooks';
import { openDialog } from '@/redux/slices/pageSlice';
import { motion } from 'framer-motion';
import { containerDivFadeIn } from '@/constants/variants';
import PrimaryButton from '../ui/shared/Button/PrimaryButton/PrimaryButton';
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '../ui/select';
import { SortingType } from '@/lib/types/apiTypes';

interface DocumentBodyHeaderProps {
	docCount: number;
	sortOrder?: SortingType;
	handleSorting?: (sortOrder: SortingType) => void;
}

const DocumentBodyHeader: FC<DocumentBodyHeaderProps> = ({
	docCount,
	sortOrder,
	handleSorting,
}) => {
	const dispatch = useAppDispatch();
	return (
		<motion.div
			className="z-10 flex items-center justify-between px-8 pt-8 pb-1"
			key="containerDivFadeIn"
			variants={containerDivFadeIn}
			initial="initial"
			animate="animate"
		>
			<h1 className="px-5 font-bold text-black dynamic-large ">
				{docCount ?? 0} Documents Found
			</h1>
			<div className="flex gap-4">
				<Select
					value={sortOrder}
					onValueChange={(sortOrder: SortingType) => {
						handleSorting && handleSorting(sortOrder);
					}}
				>
					<SelectTrigger className="h-13 w-52 rounded-xl dynamic-small border border-primary bg-white text-black px-4 hover:bg-[#EAF1FC] disabled:bg-[#F5F5F5]">
						<SelectValue placeholder="Sort by" />
					</SelectTrigger>
					<SelectContent className="py-2 bg-white rounded-xl">
						<SelectItem
							className="text-black dynamic-small py-2 cursor-pointer rounded-lg hover:bg-[#E3EEFF] hover:text-primary"
							value="DESC"
						>
							Sort by latest
						</SelectItem>
						<SelectItem
							className="text-black dynamic-small cursor-pointer rounded-lg py-2 hover:bg-[#E3EEFF] hover:text-primary"
							value="ASC"
						>
							Sort by oldest
						</SelectItem>
					</SelectContent>
				</Select>
				<PrimaryButton
					onClick={() =>
						dispatch(
							openDialog({
								type: 'uploadDocument',
								uploadDocumentType: 'uploadOrganizationalDocument',
							})
						)
					}
				>
					<Plus />
					Add New Document
				</PrimaryButton>
			</div>
		</motion.div>
	);
};

export default DocumentBodyHeader;
